import {
  getParent, IAnyModelType, IAnyStateTreeNode, IReferenceType, resolveIdentifier, types,
} from 'mobx-state-tree';
import { getMSTGQLRefLabelAndId } from 'mst-gql';

type StoreParent = { store?: IAnyStateTreeNode };

/**
 * MSTGQLRef with destroy/detach splicing. mst-gql create-then-set never rebinds
 * the default watcher; RouteTimeline.afterAttach recreates these refs in-store.
 */
export function safeMstGqlRef<T extends IAnyModelType>(
  targetType: T,
  label = targetType.name,
): IReferenceType<T> {
  return types.reference(targetType, {
    get(labeledId, parent) {
      if (!parent) return undefined;
      const store = (parent as StoreParent).store
        ?? getParent<StoreParent>(parent)?.store;
      if (!store) return undefined;
      return resolveIdentifier(
        targetType,
        store,
        getMSTGQLRefLabelAndId(String(labeledId)).id,
      );
    },
    set(value) {
      return `${label}::${value.id}`;
    },
    onInvalidated(ev) {
      if (ev.cause === 'destroy' || ev.cause === 'detach') {
        ev.removeRef();
      }
    },
  });
}
